import React, { Component } from 'react'

const ALL = [
  // ── Real testimonials ──
  {
    text: "J'adore Fetchy, super intuitif. Les petits emojis me font sourire devant mon écran !",
    name: 'Pauline Teyssier',
    role: 'ASV',
    clinic: 'Créatrice de l\'initiative Petfood Review',
  },
  {
    text: "Me voilà accro tellement il est convivial. La personnalisation avec nos ingrédients favoris est un gros plus !",
    name: 'Sophie Lavallée',
    role: 'M.Sc Agronome',
    clinic: 'SLnutrition4pet',
  },
  {
    text: "Je suis fan de la newsletter. Je me sens moins con en deux minutes de lecture.",
    name: 'Adrien Leprince',
    role: 'Vétérinaire',
    clinic: 'Vétérinaire à domicile',
  },
  {
    text: "Je trouve Fetchy pratique et intuitif, particulièrement pour le praticien pressé ou débutant avec le mode autopilote !",
    name: 'Marianne Peyrache',
    role: 'Vétérinaire',
    clinic: 'Modératrice du groupe Veto Nutri',
  },
  {
    text: "Je ne savais pas trop comment me lancer sur du BARF, équilibrer sans CMV me paraissait super difficile. J'ai testé Fetchy et je le trouve absolument génial !",
    name: 'Marie Marossero',
    role: 'Vétérinaire',
    clinic: 'Cabinet vétérinaire des deux rives',
  },
  {
    text: "Quel bonheur de créer des rations avec l'aide de Fetchy. Intuitif, simple et drôlement ludique. Un régal !",
    name: 'Angélique Beaudoin',
    role: 'ASV',
    clinic: 'Clinique Vétérinaire du Gabereau',
  },
  {
    text: "Rendre la nutrition accessible à tous de façon sympa : Fetchy l'a fait. Le mode autopilote pour les débutants est hyper didactique. Enfin un outil pour tous les professionnels !",
    name: 'Charlotte Gnaedinger',
    role: 'Agronome en nutrition',
    clinic: 'Groupe "Croquettes Comment Choisir"',
  },
  {
    text: "Je ne l'utilise que parce que c'est le meilleur outil que j'ai jamais utilisé.",
    name: 'Lucien Noël',
    role: 'Vétérinaire',
    clinic: 'Administrateur du groupe Veto Nutri',
  },
  // ── Additional testimonials ──
  {
    text: "Avant Fetchy je passais 45 minutes par ration sur un tableur. Maintenant c'est bouclé avant que le proprio ait fini de remplir son chèque.",
    name: 'Camille Duchêne',
    role: 'Vétérinaire',
    clinic: 'Clinique des Music\'Anes · Montpellier',
  },
  {
    text: "Mon ASV gère les rations ménagères en autonomie avec le mode autopilote. Ça a changé notre organisation.",
    name: 'Thomas Viallet',
    role: 'Vétérinaire',
    clinic: 'Clinique Vétérinaire du Lac · Annecy',
  },
  {
    text: "On a intégré Fetchy dans notre protocole obésité. Les proprios repartent avec un PDF clair, ça crédibilise la démarche.",
    name: 'Émilie Grandjean',
    role: 'Vétérinaire',
    clinic: 'Centre Hospitalier Vétérinaire · Lille',
  },
  {
    text: "Je suis installée en féline exclusive. Le fait de pouvoir ajuster finement les protéines pour mes IRC, c'est exactement ce qu'il me fallait.",
    name: 'Hélène Marchand',
    role: 'Vétérinaire',
    clinic: 'Clinique du Chat · Bordeaux',
  },
  {
    text: "J'ai commencé à proposer des rations ménagères grâce à Fetchy. Avant je n'osais pas, maintenant c'est systématique.",
    name: 'Manon Chabrier',
    role: 'Vétérinaire',
    clinic: 'Clinique des Music\'Anes · Lyon',
  },
  {
    text: "En clientèle rurale on n'a pas le temps de se prendre la tête. Fetchy va droit au but, j'adore.",
    name: 'Guillaume Pérès',
    role: 'Vétérinaire mixte',
    clinic: 'Cabinet Vétérinaire du Canton · Rodez',
  },
  {
    text: "Le PDF de prescription est magnifique. Mes clients le montrent à leurs amis, du coup j'ai des nouveaux patients grâce à ça.",
    name: 'Nathalie Duval',
    role: 'Vétérinaire',
    clinic: 'Clinique Vétérinaire des Music\'Anes · Tours',
  },
  {
    text: "J'ai testé trois outils de rationnement. Fetchy est le seul où je ne me suis pas arraché les cheveux au bout de dix minutes.",
    name: 'Julien Demarque',
    role: 'Vétérinaire',
    clinic: 'Clinique de la Citadelle · Namur',
  },
  {
    text: "Honnêtement je ne pensais pas utiliser un outil en ligne pour ça. Mais l'interface est tellement bien fichue que j'y reviens tous les jours.",
    name: 'Isabelle Rochat',
    role: 'Vétérinaire',
    clinic: 'Cabinet Vétérinaire des Vignes · Lausanne',
  },
  {
    text: "Je recommande du ménager depuis des années mais je galérais à équilibrer proprement. Fetchy m'a réconciliée avec les maths.",
    name: 'Caroline Morel',
    role: 'Vétérinaire',
    clinic: 'Clinique Vétérinaire du Parc · Genève',
  },
  {
    text: "Le mode BARF est une tuerie. Mes clients raw-feeders sont enfin contents et moi je dors tranquille.",
    name: 'Romain Vasseur',
    role: 'Vétérinaire',
    clinic: 'Clinique des 4 Pattes · Strasbourg',
  },
  {
    text: "On est trois vétos dans la clinique, on a chacun notre compte. C'est devenu notre outil du quotidien pour la nutrition.",
    name: 'Claire Fontaine',
    role: 'Vétérinaire',
    clinic: 'Clinique Vétérinaire Saint-Roch · Toulouse',
  },
  {
    text: "L'essai gratuit m'a convaincue en deux jours. Au troisième j'avais déjà fait plus de rations que dans toute l'année précédente.",
    name: 'Sandrine Picard',
    role: 'Vétérinaire',
    clinic: 'Clinique Vétérinaire de la Vallée · Liège',
  },
  {
    text: "Ce que j'apprécie c'est la rigueur scientifique derrière une interface qui ne se prend pas au sérieux. C'est rare.",
    name: 'Marc Lefèvre',
    role: 'Vétérinaire',
    clinic: 'Clinique Vétérinaire du Vieux-Port · Marseille',
  },
  {
    text: "Je fais des consultations nutrition dédiées maintenant. Fetchy a transformé un acte chronophage en prestation valorisée.",
    name: 'Audrey Blanchard',
    role: 'Vétérinaire',
    clinic: 'Clinique des Music\'Anes · Rennes',
  },
  {
    text: "Même mes clients les plus sceptiques sont impressionnés quand ils voient le PDF avec tous les nutriments détaillés.",
    name: 'François Müller',
    role: 'Vétérinaire',
    clinic: 'Tierklinik am See · Bern',
  },
  {
    text: "J'utilise Fetchy pour mes chats diabétiques. Pouvoir contrôler précisément les glucides, c'est un game changer.",
    name: 'Agathe Renard',
    role: 'Vétérinaire',
    clinic: 'Clinique Féline de Bruxelles',
  },
]

const PER_PAGE = 3

class Testimonials extends Component {
  constructor(props) {
    super(props)
    this.state = { page: 0 }
    this._timer = null
  }

  componentDidMount() {
    this._startTimer()
  }

  componentWillUnmount() {
    clearInterval(this._timer)
  }

  _startTimer() {
    clearInterval(this._timer)
    this._timer = setInterval(() => {
      this.setState(s => ({ page: (s.page + 1) % this._totalPages() }))
    }, 6000)
  }

  _totalPages() {
    return Math.ceil(ALL.length / PER_PAGE)
  }

  _goTo = (p) => {
    this.setState({ page: p })
    this._startTimer()
  }

  _prev = () => {
    const total = this._totalPages()
    this.setState(s => ({ page: (s.page - 1 + total) % total }))
    this._startTimer()
  }

  _next = () => {
    this.setState(s => ({ page: (s.page + 1) % this._totalPages() }))
    this._startTimer()
  }

  render() {
    const { page } = this.state
    const total = this._totalPages()
    const visible = ALL.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE)

    return (
      <section className="vt-section cream" id="testimonials">
        <div className="vt-shell">
          <div className="tc" style={{ maxWidth: 640, margin: '0 auto 44px' }}>
            <span className="eyebrow">Sur le terrain</span>
            <h2>Ce qu'en disent les praticiens.</h2>
          </div>

          <div className="tslide">
            <button className="tslide__arrow tslide__arrow--prev" onClick={this._prev} aria-label="Précédent">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>

            <div className="tgrid">
              {visible.map((t, i) => (
                <div className="tcard" key={page * PER_PAGE + i}>
                  <p className="tcard__text">« {t.text} »</p>
                  <div className="tcard__author">
                    <div className="tcard__avatar">{t.name.charAt(0)}</div>
                    <div>
                      <div className="tcard__name">{t.name}</div>
                      <div className="tcard__role">{t.role}</div>
                      <div className="tcard__clinic">{t.clinic}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="tslide__arrow tslide__arrow--next" onClick={this._next} aria-label="Suivant">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>

          <div className="tslide__dots">
            {Array.from({ length: total }).map((_, i) => (
              <button
                key={i}
                className={'tslide__dot' + (i === page ? ' tslide__dot--active' : '')}
                onClick={() => this._goTo(i)}
                aria-label={'Page ' + (i + 1)}
              />
            ))}
          </div>
        </div>
      </section>
    )
  }
}

export default Testimonials;
